const colors = {
  primary: '#218cf0',
  // primary: '#0055ff',

}

export default colors;